<div class="loaderwrapper" *ngIf="this.loader">
    <span class="loader"></span>
</div>
<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="card table-card">
            <!-- Title, filters and the page action share one row at the top
                 of the card rather than stacking above it. -->
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Source</h1>
                <button type="button" class="btn btn-dark rounded" (click)="addSourceOpen(addConent)"
                    *ngIf="permissionsReady && permissions.canAdd">
                    <i class="ri-add-line label-icon align-middle fs-16"></i>
                    Add New
                </button>
            </div>
            <div class="table-wrap" [class.is-loading]="tableLoader">
                <div class="loaderwrapper" *ngIf="tableLoader">
                    <span class="loader"></span>
                </div>
                <div class="table-main">
                    <table class="table-data">
                        <thead>
                            <tr>
                                <th scope="col">Sr. No</th>
                                <th scope="col">Source Name</th>
                                <th scope="col" style="width: 80px;text-align: center;" *ngIf="hasAnyActionPermission">
                                    Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of source; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.getName() }}</td>
                                <td style="width: 40px;text-align: center" *ngIf="hasAnyActionPermission">
                                    <div class="  d-flex justify-content-center"
                                        *ngIf="permissionsReady && permissions.canEdit">
                                        <button type="button" (click)="open(item, content)"
                                            class="dropdown-item editcategory d-inline" data-toggle="modal"
                                            data-target="#edit-category-vt">

                                            <!-- <i class="bx bx-edit"></i> -->
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.433" height="18"
                                                viewBox="8 4 14.433 18">
                                                <path
                                                    d="M8.9 20.2h12.6a.9.9 0 0 1 0 1.8H8.9a.9.9 0 1 1 0-1.8ZM8 15.7l9-9 2.7 2.7-9 9H8v-2.7Zm9.9-9.9L19.7 4l2.7 2.7-1.8 1.8-2.7-2.7Z"
                                                    fill="currentColor" />
                                            </svg>
                                        </button>
                                        <button (click)="deleteSource(item)" type="button"
                                            *ngIf="permissionsReady && permissions.canDelete"
                                            class="dropdown-item deletecategory d-inline">
                                            <!-- <i class=" ri-close-circle-line  "></i>  -->
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15.017" height="18"
                                                viewBox="9 6 15.017 18">
                                                <path
                                                    d="M10.5 22.004c0 1.098.9 1.996 2 1.996h8c1.1 0 2-.898 2-1.996V10.5h-12v11.504ZM24 7.5h-3.75L18.994 6h-4.988L12.75 7.5H9V9h15V7.5Z"
                                                    fill="currentColor" />
                                            </svg>

                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <!-- NO VIEW PERMISSION -->
                            <tr *ngIf="permissionsReady && !permissions.canView">
                                <td colspan="100%">
                                    <div class="no-access text-center p-4">
                                        You don’t have permission to view this data.
                                    </div>
                                </td>
                            </tr>

                            <!-- NO RECORDS -->
                            <tr *ngIf="permissionsReady && permissions.canView && (!source || source.length === 0)">
                                <td colspan="100%">
                                    <p class="not-found-message p-4 text-center">
                                        No records found.
                                    </p>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #addConent let-c="close" let-d="dismiss">
    <!-- (ngSubmit)="cardDetail(payment,content)" #payment="ngForm" -->
    <form [formGroup]="addSourceForm" (ngSubmit)="addSource()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Add Source</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.633" height="14.25"
                    viewBox="1222.583 108.567 13.633 14.25">
                    <g data-name="Group 2829">
                        <g data-name="chevron-back">
                            <path d="m1224 110 5.393 5.393 5.393-5.393" stroke-linejoin="round" stroke-linecap="round"
                                stroke-width="2" stroke="#fff" fill="transparent" data-name="Path 5498" />
                        </g>
                        <g data-name="chevron-back">
                            <path d="m1224 121.393 5.393-5.393 5.392 5.393" stroke-linejoin="round"
                                stroke-linecap="round" stroke-width="2" stroke="#fff" fill="transparent"
                                data-name="Path 5498" />
                        </g>
                    </g>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 form-styles">
                    <label for="typeahead-basic">Name:</label>
                    <input id="typeahead-basic" type="text" class="form-control" formControlName="sourcName"
                        maxlength="50" />
                    <small class="text-danger" *ngIf="
                            !addSourceForm?.get('sourcName').valid &&
                            addSourceForm?.get('sourcName').touched
                        ">Please Enter Source Name</small>
                </div>
            </div>
        </div>
        <!-- (click)="c('Save click')" -->
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click')">
                Cancel
            </button>
            <button type="button" class="btn btn-orange" [disabled]="addSourceForm.invalid" (click)="c('Save click')"
                type="submit">
                Save
            </button>
        </div>
    </form>
</ng-template>
<ng-template #content let-c="close" let-d="dismiss">
    <!-- (ngSubmit)="cardDetail(payment,content)" #payment="ngForm" -->
    <form [formGroup]="updateSourceForm" (ngSubmit)="updateSource()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Update Source</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.633" height="14.25"
                    viewBox="1222.583 108.567 13.633 14.25">
                    <g data-name="Group 2829">
                        <g data-name="chevron-back">
                            <path d="m1224 110 5.393 5.393 5.393-5.393" stroke-linejoin="round" stroke-linecap="round"
                                stroke-width="2" stroke="#fff" fill="transparent" data-name="Path 5498" />
                        </g>
                        <g data-name="chevron-back">
                            <path d="m1224 121.393 5.393-5.393 5.392 5.393" stroke-linejoin="round"
                                stroke-linecap="round" stroke-width="2" stroke="#fff" fill="transparent"
                                data-name="Path 5498" />
                        </g>
                    </g>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 form-styles">
                    <label for="typeahead-basic">Name:</label>
                    <input id="typeahead-basic" type="text" class="form-control" formControlName="sourcNameupdate"
                        maxlength="50" />
                    <small class="text-danger" *ngIf="
                            !updateSourceForm?.get('sourcNameupdate').valid &&
                            updateSourceForm?.get('sourcNameupdate').touched
                        ">Please Enter Source Name</small>
                </div>
            </div>
        </div>
        <!-- (click)="c('Save click')" -->
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click')">
                Cancel
            </button>
            <button type="button" class="btn btn-orange" [disabled]="updateSourceForm.invalid" (click)="c('Save click')"
                type="submit">
                Save
            </button>
        </div>
    </form>
</ng-template>